<template>
  <b-modal
    id="template-missing-modal"
    ref="templateMissingModalRef"
    class="static-modal"
    hide-header-close
    static
    centered
    no-fade
    size="lg"
    @cancel="removeModal" >
    <!-- Header -->
    <template #modal-header>
      Start a conversation with {{ number }}
    </template>

    <!-- Body -->
    <div class="body-wrapper flex column">
      <span class="icon"></span>
      <h3>WhatsApp Message Templates Required</h3>
      <p>To initiate a conversation with this contact WhatsApp requires
        a Message Template format to be used. Learn more about
        WhatsApp Message Templates and WhatsApp commerce
        policies
        <a
          href="https://developers.facebook.com/docs/whatsapp/message-templates/creation"
          target="_blank">here</a>.
      </p>
    </div>

    <!-- Footer -->
    <template #modal-footer="{ cancel }">
      <b-button
        variant="secondary"
        @click="cancel()">
        Cancel
      </b-button>
      <b-button
        variant="primary"
        class="flex"
        @click="goToTemplates">
        Create
        <!-- <SBIcon
          class="ml-1 mr-1 top-1"
          :icon="SBIconList.WHATSAPP_LOGO_THICK"
          :color="SBColors.white"
          :size="14"/>
        Message Template -->
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'TemplateMissingModal',
  components: {
    SBIcon,
  },
  data() {
    return {
      number: '',
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
    }),
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    activeConversation() {
      // Cancel template modal if conversation is changed while template modal is opened for previous conversation.
      this.hide();
    },
  },
  mounted() {
    this.$eventBus.$on('show-template-missing-modal', this.show);
    this.$eventBus.$on('close-template-missing-modal', this.hide);
  },
  beforeDestroy() {
    this.$eventBus.$off('show-template-missing-modal', this.show);
    this.$eventBus.$off('close-template-missing-modal', this.hide);
  },
  methods: {
    goToTemplates() {
      // this.activeConversation.openSendNotification = false;

      this.$emit('create-new-template');
    },
    removeModal() {
      // this.$eventBus.$emit('remove-new-temp-conversation');
      this.activeConversation.openSendNotification = false;
    },
    hide() {
      this.$refs.templateMissingModalRef.hide();
    },
    show(number) {
      this.number = number;
      this.$refs.templateMissingModalRef.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.top-1 {
  top: 1px;
}

::v-deep #template-missing-modal {
  .modal-dialog {
    max-width: 484px !important;
    .modal-header {
      font-weight: 500;
      font-size: 16px;
      line-height: 1.2;
      color: $blackPrimary;
    }

    .modal-content .modal-body {
      background: $white !important;
    }

    .body-wrapper {
      padding: 20px;
      border-radius: 5px;
      border: solid 1px #e1e5eb;
      background-color: #f8fbff;

      .icon {
        height: 68px;
        background-image: url('~@/assets/img/SB-Images/template-missing.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }

      h3 {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.05;
        text-align: center;
        color: $blackPrimary;
        margin: 15px 0 10px;
      }

      p {
        font-size: 14px;
        line-height: 1.2;
        text-align: center;
        color: $blackPrimary;

        a {
          text-decoration: underline;
          color: inherit;
        }
      }
    }
  }
}
</style>
